module.exports = __webpack_public_path__ + "img/bjcontact.86c7b468.png";